import { PanoramaSphereOutlineIcon } from './PanoramaSphereOutlineIcon';

/**
 * author: Google
 * id F364E6E7-1129-4076-B915-0DA77003C891
 * name panorama-sphere-outline
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/panorama-sphere-outline.svg
 * tags
 * - Photography 
 */
export const Panorama360OutlineIcon = PanoramaSphereOutlineIcon;
export default Panorama360OutlineIcon